import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Thin orange announcement strip highlighting flagship epoxy service
export default function FlagshipStrip() {
  return (
    <Link
      to="/epoxy-flooring"
      data-testid="flagship-epoxy-strip"
      className="group block bg-orange text-white hover:bg-orange-dark transition-colors"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-4 md:py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-3 md:gap-5">
          <span className="font-mono text-[10px] tracking-[0.3em] uppercase bg-white/20 backdrop-blur px-2.5 py-1">
            Flagship
          </span>
          <span className="font-display text-base md:text-lg tracking-tight">
            Epoxy Flooring — Pan India delivery for industrial, warehouse
            &amp; factory projects
          </span>
        </div>
        <span className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase whitespace-nowrap">
          Explore
          <ArrowUpRight
            size={14}
            className="transition-transform group-hover:rotate-45"
          />
        </span>
      </div>
    </Link>
  );
}
